import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Permissions from "../../../../lib/regular/permissions";
import { Checkbox, Button } from "antd";

// eslint-disable-next-line
/* eslint-disable react-hooks/exhaustive-deps */
const AssignPermissionsForm = (props) => {
  const { setSelectedPermissions, selectedPermissions, availablePermissions } = props;

  const onPermissionCheck = (values) => {
    setSelectedPermissions(values);
  };

  const renderCheckAllBtns = () => {
    const availablePermissionsIds = Permissions.getPermissionIdsArray(availablePermissions);

    return (
      <div className="check-all-btns">
        <Button onClick={() => setSelectedPermissions(availablePermissionsIds)}>Check All</Button>
        <Button onClick={() => setSelectedPermissions([])} danger>
          Uncheck All
        </Button>
      </div>
    );
  };

  const renderCheckboxes = () => {
    const options = Permissions.getOptionsFromPermissions(availablePermissions);

    return (
      <Checkbox.Group
        className="permissions-checkboxes"
        options={options}
        onChange={onPermissionCheck}
        value={selectedPermissions}
      />
    );
  };

  return useMemo(() => {
    return (
      <div className="assign-permissions-form">
        <h3 className="header">PERMISSIONS</h3>
        {renderCheckAllBtns()}
        {renderCheckboxes()}
      </div>
    );
  }, [selectedPermissions]);
};

AssignPermissionsForm.propTypes = {
  setSelectedPermissions: PropTypes.func.isRequired,
  selectedPermissions: PropTypes.array.isRequired,
  availablePermissions: PropTypes.array.isRequired,
  isSecondCloset: PropTypes.bool,
};

export default AssignPermissionsForm;
